module.exports = __webpack_public_path__ + "static/media/Partnerships.e8bd4ce9.jpg";